if ( typeof PickupAvailabilityCompact !== 'function' ) {

  class PickupAvailabilityCompact extends HTMLElement {

    constructor(){

      super();
      this.classList.add('active');

      const widgetIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.fetchAvailability(this.dataset.variantId);
      }
      new IntersectionObserver(widgetIntersection.bind(this), {rootMargin: '0px 0px 50px 0px'}).observe(this);

      this.storeSelector = document.querySelector('store-selector[data-main-selector]');
      window.addEventListener('load', ()=>{
        if ( this.storeSelector ) {
          this.storeSelector.addEventListener('storechanged', e=>{
            this.fetchAvailability(this.dataset.variantId);
          })
        }
      })

    }

    fetchAvailability(variantId) {

      const variantSectionUrl = `${this.dataset.baseUrl}/variants/${variantId}/?section_id=helper-pickup-availability-compact`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(e => {
          console.log(e);
        });

    }

    renderPreview(sectionInnerHTML) {
      const selectedStore = localStorage.getItem('selected-store');

      // search based on selected store
      let storeFound = false;
      const availStores = []
      const unavailStores = []

      this.innerHTML = '';
      const availableDiv = document.createElement('div');
      const unavailableDiv = document.createElement('div');

      let unavailCount = sectionInnerHTML.querySelectorAll('.unavailable').length;

      sectionInnerHTML.querySelectorAll('[data-store]').forEach(elm=>{

        if (elm.dataset.store) {
          if (elm.classList.contains('available') && availStores.indexOf(this.storeSelector.storesList[elm.dataset.store]) == -1) {
            storeFound = true;

            if (!availStores.includes(this.storeSelector.storesList[elm.dataset.store])) {
              availStores.push(this.storeSelector.storesList[elm.dataset.store])
            }

            // var joinedString = availStores.slice(0, -1).join(", ");

            // var finalString = (availStores.length > 1 ? joinedString + ' & ' : '') + availStores[availStores.length - 1];

            var finalString = availStores.map((store, index) => {
              return `<span class="!inline-flex gap-2 items-center px-2 py-1 text-xs bg-[#D4D5D5] text-black rounded-full pointer-events-none">${store}</span>`
            })

            availableDiv.innerHTML = elm.innerHTML.replace('{{ store }}', `<div class="flex justify-center gap-2 flex-wrap mt-2">${finalString.join('')}</div>`)
          } else {
            // unavailStores.push(this.storeSelector.storesList[elm.dataset.store])
            // unavailableDiv.innerHTML = elm.innerHTML.replace('{{ store }}', unavailStores.join(unavailCount >= 1 ? ', ' : ' & '))
            // unavailCount++;
          }
        }
      })

      this.appendChild(availableDiv);
      this.appendChild(unavailableDiv);
      this.style.display = 'block';

      // console.log(this.closest('form'));

      // for (let i = 0; i < availStores.length; i++) {
      //   const element = availStores[i];
      //   const input = document.createElement('input');
      //   input.type = 'hidden';
      //   input.name = 'properties[pickup-store]';
      //   input.value = element;
      //   this.appendChild(input);
      // }


      // if ( this.storeSelector && selectedStore && this.storeSelector.storesList[selectedStore] ) {
      //   // search based on selected store
      //   let storeFound = false;
      //   if ( selectedStore ) {
      //     const availStores = []
      //     const unavailStores = []

      //     this.innerHTML = '';
      //     const availableDiv = document.createElement('div');
      //     const unavailableDiv = document.createElement('div');

      //     let unavailCount = sectionInnerHTML.querySelectorAll('.unavailable').length;

      //     sectionInnerHTML.querySelectorAll('[data-store]').forEach(elm=>{

      //       if (elm.dataset.store) {
      //         if (elm.classList.contains('available') && availStores.indexOf(this.storeSelector.storesList[elm.dataset.store]) == -1) {
      //           storeFound = true;

      //           availStores.push(this.storeSelector.storesList[elm.dataset.store])

      //           console.log(this.storeSelector.storesList, availStores, elm.dataset.store);
      //           var joinedString = availStores.slice(0, -1).join(", ");
      //           console.log(joinedString);
      //           var finalString = (availStores.length > 1 ? joinedString + ' & ' : '') + availStores[availStores.length - 1];

      //           availableDiv.innerHTML = elm.innerHTML.replace('{{ store }}', finalString)
      //         } else {
      //           unavailStores.push(this.storeSelector.storesList[elm.dataset.store])
      //           unavailableDiv.innerHTML = elm.innerHTML.replace('{{ store }}', unavailStores.join(unavailCount >= 1 ? ', ' : ' & '))
      //           unavailCount++;
      //         }
      //       }

      //       this.appendChild(availableDiv);
      //       this.appendChild(unavailableDiv);

      //       console.log(this);
      //       this.style.display = 'block';
      //     })
      //   }
      //   if ( !storeFound ) {
      //     this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-alert[data-default-unavailable]').innerHTML.replace('{{ store }}', this.storeSelector.storesList[selectedStore]);
      //     storeFound = true;

      //     console.log('unavailable');
      //   }
      //   if ( !selectedStore || !storeFound ) {
      //     this.innerHTML = '';
      //   }
      // } else {
      //   // search based on default store
      //   this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-alert[data-default-store]').innerHTML;
      // }
    }
  }

  if ( typeof customElements.get('pickup-availability-compact') == 'undefined' ) {
    customElements.define('pickup-availability-compact', PickupAvailabilityCompact);
	}

}

if ( typeof PickupAvailabilityExtended !== 'function' ) {

  class PickupAvailabilityExtended extends HTMLElement {

    constructor() {
      super();
      this.classList.add('active');
      this.fetchAvailability(this.dataset.variantId);
    }


    fetchAvailability(variantId) {

      const variantSectionUrl = `${this.dataset.baseUrl}/variants/${variantId}/?section_id=helper-pickup-availability-extended`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(e => {
          console.log(e);
        });

    }

    renderPreview(sectionInnerHTML) {
      const availabilityWidget = sectionInnerHTML.querySelector('#PickupAvailabilityWidget');
      if ( availabilityWidget ) {
        this.innerHTML = availabilityWidget.innerHTML;
        this.querySelectorAll('.pickup-availability-widget__location-view').forEach(elm=>{
          elm.addEventListener('click', ()=>{
            document.getElementById(`${elm.getAttribute('aria-controls')}`).classList.toggle('opened');
            elm.setAttribute('aria-selected', elm.getAttribute('aria-selected') == "true" ? "false" : "true");
          })
        })
      } else {
        console.log('error in availablity fetch');
      }

      const availabilitySidebar = sectionInnerHTML.querySelector('#PickupAvailabilitySidebar');
      if ( availabilitySidebar ) {
        if ( document.querySelector('sidebar-drawer#site-availability-sidebar') ) {
          document.querySelector('sidebar-drawer#site-availability-sidebar').remove();
        }
        document.body.appendChild(availabilitySidebar.querySelector('#site-availability-sidebar'));
        document.querySelector('.pickup-availability-widget__more').addEventListener('click', e=>{
          e.preventDefault();
          document.getElementById('site-availability-sidebar').show();
        })
      }

    }

  }

  if ( typeof customElements.get('pickup-availability-extended') == 'undefined' ) {
    customElements.define('pickup-availability-extended', PickupAvailabilityExtended);
	}

}